<template>
  <div>
    <v-dialog persistent v-model="show" max-width="760">
      <v-card>
        <v-card-title class="headline">Tarifas</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  :error-messages="descripcionErrors"
                  @input="$v.objetoDescuento.Descripcion.$touch()"
                  @blur="$v.objetoDescuento.Descripcion.$touch()"
                  v-model="objetoDescuento.Descripcion"
                  autofocus
                  dense
                  label="Descripción"
                ></v-text-field>
              </v-col>
              <v-row v-if="!objetoDescuento.Tarifa.Paqueteria">
                <v-col cols="12">
                  <span style="font-size:30px;">Mensajería</span>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    @focus="$event.target.select()"
                    dense
                    outlined
                    label="Economy"
                    v-model="objetoDescuento.Tarifa.Economy.Mensajeria"
                  >
                  </v-text-field>
                  <v-text-field
                    @focus="$event.target.select()"
                    dense
                    outlined
                    label="Primary"
                    v-model="objetoDescuento.Tarifa.Primary.Mensajeria"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12"><span style="font-size:30px;">Paquetería</span></v-col>
                <v-col cols="12">
                  <v-text-field
                    @focus="$event.target.select()"
                    dense
                    outlined
                    label="Economy"
                    v-model="objetoDescuento.Tarifa.Economy.Paqueteria"
                  >
                  </v-text-field>
                  <v-text-field
                    @focus="$event.target.select()"
                    dense
                    outlined
                    label="Primary"
                    v-model="objetoDescuento.Tarifa.Primary.Paqueteria"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- {{ objetoDescuento }} -->
              <TablaTarifas
                @pasarTarifaHaciaModal="asignarTarifa($event)"
                :Tarifas="objetoDescuento.Tarifa"
                v-if="objetoDescuento.Tarifa.Paqueteria"
              />
              <!-- {{ objetoDescuento.Tarifa }} -->
              <!-- <v-col cols="12">
                <v-text-field
                  @input="$v.objetoDescuento.Tarifa.$touch()"
                  @blur="$v.objetoDescuento.Tarifa.$touch()"
                  v-model="objetoDescuento.Tarifa"
                  dense
                  label="Porcentaje"
                ></v-text-field>
              </v-col> -->
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="$emit('cerrar-modal-descuento')" text
            >Cancelar</v-btn
          >
          <v-btn color="blue darken-1" @click="insertarDescuento()" text>Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="loaderDescuentos">
      <v-progress-circular indeterminate size="100"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";

const descripcionRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñ0-9 !@#$%^&*/|().,´"'_+]||[\n]){1,30})$/;
const porcentajeRegex = /^([0-9]{1,2})$/;
import TablaTarifas from "@/components/TablaTarifas.vue";

export default {
  components: {
    TablaTarifas
  },
  validations: {
    objetoDescuento: {
      Descripcion: {
        required,
        descripcionValida(Descripcion) {
          return descripcionRegex.test(Descripcion);
        }
      },
      Tarifa: {
        // required,
        // porcentajeValida(Porcentaje) {
        //   return porcentajeRegex.test(Porcentaje);
        // },
      }
    }
  },
  data: () => ({
    loaderDescuentos: false,
    voyAInsertar: true,
    objetoDescuento: {
      Descripcion: "",
      Tarifa: ""
    }
  }),
  props: {
    descuentoPasado: Object,
    show: Boolean
  },
  mounted() {
    if (this.descuentoPasado.ID) {
      this.voyAInsertar = false;
      this.objetoDescuento.Descripcion = JSON.parse(
        JSON.stringify(this.descuentoPasado.DESCRIPCIÓN)
      );
      this.objetoDescuento.Tarifa = JSON.parse(JSON.stringify(this.descuentoPasado.TARIFA));
      //this.objetoDescuento.Porcentaje = this.descuentoPasado.PORCENTAJE.replace(/%/gi, '');
      this.objetoDescuento.Id = this.descuentoPasado.ID;
    } else {
      this.voyAInsertar = true;
      this.objetoDescuento.Tarifa={};
      this.objetoDescuento.Tarifa.Primary={};
      this.objetoDescuento.Tarifa.Economy={};
      this.objetoDescuento.Tarifa.Primary.Paqueteria="";
      this.objetoDescuento.Tarifa.Economy.Paqueteria="";
      this.objetoDescuento.Tarifa.Economy.Mensajeria="";
      this.objetoDescuento.Tarifa.Primary.Mensajeria="";
    }
  },
  computed: {
    ...mapState("descuentos", {
      descuentosList: state => state.descuentos
    }),
    descripcionErrors() {
      const errors = [];
      if (!this.$v.objetoDescuento.Descripcion.$dirty) return errors;
      !this.$v.objetoDescuento.Descripcion.required &&
        errors.push("El campo descripción es requerido.");
      !this.$v.objetoDescuento.Descripcion.descripcionValida &&
        errors.push("El campo descripción no tiene el formato correcto.");
      return errors;
    },
    porcentajeErrors() {
      // const errors = [];
      // if (!this.$v.objetoDescuento.Tarifa.$dirty) return errors;
      // !this.$v.objetoDescuento.Tarifa.required
      //   && errors.push('El campo porcentaje es requerido.');
      // !this.$v.objetoDescuento.Tarifa.porcentajeValida
      //   && errors.push('El campo porcentaje no tiene el formato correcto.');
      // return errors;
    }
  },
  methods: {
    ...mapActions("tarifas", ["insertTarifas", "editTarifas"]),
    async asignarTarifa(tar) {
      this.objetoDescuento.Tarifa = tar;
    },
    async insertarDescuento() {
      this.$v.$touch();
      if (this.$v.$invalid) {
      } else if (this.voyAInsertar) {
        this.loaderDescuentos = true;

        const res = await this.insertTarifas(this.objetoDescuento);
        if (res[0]) {
          this.$emit("muestraDialogExito", "Descuento insertado con éxito");
          this.loaderDescuentos = false;
        } else {
          this.$emit("muestraModalErrorEnAccion", res[1]);
          this.loaderDescuentos = false;
        }
      } else {
        this.loaderDescuentos = true;
        console.warn(this.objetoDescuento);
        const res = await this.editTarifas(this.objetoDescuento);
        if (res[0]) {
          this.$emit("muestraDialogExito", "Tarifa editada con éxito");
          this.loaderDescuentos = false;
        } else {
          this.$emit("muestraModalErrorEnAccion", res[1]);
          this.loaderDescuentos = false;
        }
      }
    }
  }
};
</script>

<style lang="css"></style>
